import { getAdmissionWorkLogAdmissionsAdmissionIdWorkLogGet as getAdmissionWorkLog } from '../../services/api/sdk.gen';
import type { EntityWorkLogDialogProps } from './EntityWorkLogDialog';
import type { WorkLogPage } from './types';

/**
 * Display names for the admission columns the work log shows. The values
 * arrive already readable: the server names UB-04 codes and referral sources,
 * so no value formatter is needed here.
 */
export const ADMISSION_WORK_LOG_FIELD_LABELS: Record<string, string> = {
  admission_type: 'Admission type',
  admission_source_code: 'Admission source',
  internal_referral_source_id: 'Internal referral source',
  referral_received_date: 'Referral date',
  face_to_face_date: 'Face-to-face date',
  notes: 'Notes',
};

/** Everything the admission work log dialog shows apart from which admission it loads. */
export const ADMISSION_WORK_LOG_DIALOG_PROPS = {
  title: 'Work log',
  fieldLabels: ADMISSION_WORK_LOG_FIELD_LABELS,
  // The day saves from the Admission tab started writing audit rows. An
  // admission created before its creation was logged opens with its first edit.
  trackedSince: '2026-08-19',
} satisfies Partial<EntityWorkLogDialogProps>;

/** One page of an admission's work log; pass a page's `next_cursor` for the next. */
export async function loadAdmissionWorkLog(
  admissionId: string,
  cursor?: string
): Promise<WorkLogPage> {
  const res = await getAdmissionWorkLog({
    path: { admission_id: admissionId },
    query: cursor ? { cursor } : undefined,
    // Resolves on a 4xx/5xx otherwise, and the dialog would read an error
    // as an empty log.
    throwOnError: true,
  });
  if (!res.data) throw new Error('No work log in response');
  return res.data;
}
